<template>
  <BannerContent v-if="currentBanner" :content="currentBanner" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BannerContent from './bannerContent'
import { useBannerStore } from './bannerStore'
const store = useBannerStore()
const currentBanner = computed(() => store.firstEligibleBanner ?? null)
</script>
